/**
 * Derive Parent/Guardian + Packet tab signed-copy button state from status payload.
 * Status fields (v2.9.11+): signed_copy_source, signed_copy_document_id, has_docuseal_signed_copy
 * (on response root and/or under packet).
 */
export function resolveSignedCopyUi(packetStatus) {
  const packet = packetStatus?.packet;
  const signedCopySource =
    packet?.signed_copy_source
    || packetStatus?.signed_copy_source
    || (packet?.archived_pdf_url ? 'archive' : null);

  const flag = packet?.has_docuseal_signed_copy ?? packetStatus?.has_docuseal_signed_copy;
  const hasDocusealSignedCopy = !!flag || signedCopySource === 'docuseal';

  return { signedCopySource, hasDocusealSignedCopy };
}
